export default __webpack_public_path__ + "static/media/AssignLocation.f1f36f39.pdf";